<template>
  <div>
    <p class="my-3 text-sm mb-0">
      Estos son algunos de los lugares donde puedes realizar tu pago:
    </p>
    <div class="flex mt-5 justify-center">
      <div v-for="store in firstRow" :key="store.name" class="w-3/12">
        <img :src="store.image" :alt="store.name" />
      </div>
    </div>
    <div class="flex mt-5 justify-center">
      <div v-for="store in secondRow" :key="store.name" class="w-3/12">
        <img :src="store.image" :alt="store.name" />
      </div>
    </div>
    <p class="text-center underline mt-4 mb-3">
      <a :href="storesUrl" target="_blank">
        Consulta aquí todos los lugares de pago
      </a>
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { PAYMENT_STORES, PAYMENT_STORES_URL } from '../constants/paymentStores';

const firstRow = computed(() => PAYMENT_STORES.slice(0, 3));
const secondRow = computed(() => PAYMENT_STORES.slice(3, 6));
const storesUrl = PAYMENT_STORES_URL;
</script>
